<div class="top-banner d-flex justify-content-between align-items-center" [class.ui-block]="ui() == 'block'">
  <div class="corp-color">
    <ng-content />
  </div>
  <div class="text-right d-flex align-items-center gap-2">
    {{ 'remaining-time' | translate }}:
    @if (!loading()) {
      <countdown
        #countdown
        [config]="{ leftTime: reservedSeconds(), format: 'mm:ss' }"
        (event)="onCountdownEnd.emit($event)"
      />
    } @else {
      <p-skeleton
        width="80px"
        height="1.5rem"
      />
    }
  </div>
</div>
